import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title, Meta } from "@angular/platform-browser";

import { ApiClientsService, ApiClient } from "../../services/api-clients/api-clients.service";
import { EventsService, Event } from "../../services/events/events.service";

let $_: any;

@Component({
    selector: 'app-agency',
    templateUrl: './agency.component.html',
    styleUrls: ['./agency.component.css']
})
export class AgencyComponent implements OnInit {

    db_read_complete: boolean = false;
    parent_agency_id: number;
    parent_agency_name: string;
    router_sub: any;
    api_clients: ApiClient[] = [];
    events: Event[] = [];

    constructor(private title_service: Title, private meta_service: Meta, private route: ActivatedRoute, private api_clients_service: ApiClientsService, private events_service: EventsService) {

        $_ = this;
    }

    ngOnInit() {

        $_.db_read_complete = false;

        $_.router_sub = this.route.params.subscribe(params => {

            $_.parent_agency_id = params['parent_agency_id'];

            $_.api_clients = $_.api_clients_service.get_api_clients($_.parent_agency_id, (api_clients) => {

                $_.api_clients = api_clients;

                var index = $_.api_clients.findIndex(api_client => api_client.agency_id === $_.parent_agency_id);

                if (index > -1) {

                    $_.parent_agency_name = $_.api_clients[index].name;
                }               

                $_.title_service.setTitle('Sinirji 911 LIVE | Live Events List for ' + $_.parent_agency_name);

                $_.events_service.get_events($_.parent_agency_id, (events) => {

                    $_.events = events;
                    $_.db_read_complete = true;
                });
            })
        });
    }

    ngOnDestroy() {

        $_.router_sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/agency/agency.component.ts